// Route: /characters/sessions/$id — чат обучающей сессии.
//
// Non-nested (`characters_.`) намеренно: родительский `/characters` рисует
// собственный экран и `<Outlet/>` не содержит — вложенный роут просто не
// отрисовался бы, а URL менялся (грабли `code-quality.md` §35).
//
// Движок один с сценой курса (`CharacterSessionBody`, layout="page").

import { createFileRoute } from "@tanstack/react-router";
import { CharacterSessionBody } from "@/components/characters/chat/character-session-body";
import { PagePendingFallback } from "@/components/shared/page-pending-fallback";

export const Route = createFileRoute("/characters_/sessions/$id")({
	component: CharacterSessionPage,
	pendingComponent: PagePendingFallback,
});

function CharacterSessionPage(): React.ReactElement {
	const { id } = Route.useParams();
	return <CharacterSessionBody sessionId={id} layout="page" />;
}
